import { Component, OnInit,HostListener, ElementRef, Renderer2, ViewChild } from '@angular/core';
import SwiperCore,{Autoplay,Keyboard,Pagination,Navigation} from 'swiper';
import { Router, RouterModule } from '@angular/router';
import { AnyARecord } from 'dns';
import { OwlOptions } from 'ngx-owl-carousel-o';




SwiperCore.use([Autoplay,Pagination,Keyboard,Navigation])

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})

/**
 * Index Component
 */
export class IndexComponent implements OnInit {

  currentSection = 'home';
  showNavigationArrows: any;
  showNavigationIndicators: any;
  @ViewChild('navbarContent', { static: false }) navbarContent!: ElementRef;
  productsList = [
    {name:'Ripple Build', test:'dummy test'},
    {name:'Ripple Care', test:'dummy test'},
    {name:'Ripple Warehousing services', test:'dummy test'},
  
  ];
  serviceList = [
    {name:'Development platforms', test:'dummy text'},
    {name:'SEO', test:'dummy text'},
    {name:'Customer notifications', test:'dummy text'},
  
  ];
  productsList1 = [
    {name:'Ripple Flash', test:'Same day delovery in metros'},
    {name:'Ripple Assist', test:'WhatsApp and Emails'},
    {name:'Ripple Assist Adv', test:'Call center support'},

  ];
  serviceList1 = [
    {name:'Payment plans and COD and change', test:'dummy text'},
    {name:'Ripple assist', test:'dummy text'},

  ];
  productsList2 = [
    {name:'Ripple Boost', test:'Marketing and ads support'},
    {name:'Ripple Trust', test:'Returns management and AI assist'},
    {name:'Ripple influence', test:'dummy text'},
  ];
  ondcList = [
    {name:'Platforms integrated with journey', test:'dummy text'},
    {name:'Sales increment plans', test:'dummy text'},
  ];
  partnerList = [
    {name:'Development partners', test:'dummy text'},
    {name:'Shipping partners', test:'dummy text'},
    {name:'Marketting partners', test:'dummy text'},

  ];





  constructor(private router :Router) { }

  currentSlide = 0;
  // Interval variable to handle auto sliding
  autoSlideInterval: any;
  currentSlide1 = 0;
  // Interval variable to handle auto sliding
  autoSlideInterval1: any;

  ngOnInit(): void {
    // Start auto sliding when the component is initialized
    this.startAutoSlide();
    this.startAutoSlide1();
    this.groupBrandImages();

  }

  ngOnDestroy(): void {
    // Clear the interval when the component is destroyed to avoid memory leaks
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
    if (this.autoSlideInterval1) {
      clearInterval(this.autoSlideInterval1);
    }
  }

  // Method to navigate to the specific slide
  goToSlide(slideIndex: number): void {
    this.currentSlide = slideIndex;
  }
  goToSlide1(slideIndex: number): void {
    this.currentSlide1 = slideIndex;
  }

  // Method to start the auto-slide feature
  startAutoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % 3; // Loop through 3 slides
    }, 6000); // Change slide every 3 seconds
  }
  startAutoSlide1(): void {
    this.autoSlideInterval1 = setInterval(() => {
      this.currentSlide1 = (this.currentSlide1 + 1) % 3; // Loop through 3 slides
    }, 6000); // Change slide every 3 seconds
  }

  // Method to check if a specific slide is active
  isActive(slideIndex: number): boolean {
    return this.currentSlide === slideIndex;
  }
  isActive1(slideIndex: number): boolean {
    return this.currentSlide1 === slideIndex;
  }
  /**
   * Window scroll method
   */
  // tslint:disable-next-line: typedef
  // windowScroll() {
  //   const navbar = document.getElementById('navbar');
  //   if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
  //     navbar?.classList.add('is-sticky');
  //   }
  //   else {
  //     navbar?.classList.remove('is-sticky');
  //   }

  //   if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
  //     (document.getElementById("back-to-top") as HTMLElement).style.display = "block"
  //   } else {
  //     (document.getElementById("back-to-top") as HTMLElement).style.display = "none"
  //   }
  // }

  isScrolled = false;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    const scrollPosition = window.scrollY || window.pageYOffset;
    this.isScrolled = scrollPosition > 100; 
  }

   /**
   * Section changed method
   * @param sectionId specify the current sectionID
   */
    onSectionChange(sectionId: string) {
      this.currentSection = sectionId;
    }

  /**
  * Toggle navbar
  */
  toggleMenu() {
    document.getElementById('navbarSupportedContent')?.classList.toggle('show');
    const element = this.navbarContent.nativeElement;
    element.classList.toggle('show');
    this.isScrolled = !this.isScrolled;

  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  customOptions1: OwlOptions = {
    loop:true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 600,
    navText: ["", ""],
        responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      425: {
        items: 1,
      },
      320: {
        items: 1,
      },
      760: {
        items: 5,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 5,
      },
      1280: {
        items:5,
      },
      1440: {
        items: 5,
      },
      1920:{
        items:5,
      }
    },
    nav: false,
    autoplay: true, 
    autoplayTimeout: 5000,
  };


  customOptions2: OwlOptions = {
    loop:true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 600,
    navText: ["<div class='nav-button owl-prev'><img src='assets/images/svg/back1.png' alt='Previous'></div>",    "<div class='nav-button owl-next'><img src='assets/images/svg/back2.png' alt='Next'></div>"],
        responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      425: {
        items: 1,
      },
      320: {
        items: 1,
      },
      760: {
        items: 2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 2,
      },
      1280: {
        items:2,
      },
      1440: {
        items: 2,
      },
      1920:{
        items:2,
      }
    },
    nav:true,
    autoplay: true, 
    autoplayTimeout: 5000,
  };


  old_brandImages = [
    // {
    //   image: "/assets/images/brands/brands1/image 53.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 54.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 55.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 56.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 57.png"
    // },

    // {
    //   image: "/assets/images/brands/brands1/image 58.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 59.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 60.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 61.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 62.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 63.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 64.png"
    // },

    // {
    //   image: "/assets/images/brands/brands1/image 67.png"
    // },
    
    // {
    //   image: "/assets/images/brands/brands1/image 69.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 70.png"
    // }, 
    // {
    //   image: "/assets/images/brands/brands1/image 72.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 73.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 74.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 75.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 76.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 77.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/image 78.png"
    // },
    
    // {
    //   image: "/assets/images/brands/brands1/layer_shot.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/nua.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/pee_safe.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/sironalogo_1 1.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/streakx.png"
    // }, 
    // {
    //   image: "/assets/images/brands/brands1/Avene_logo.png"
    // }, 
   
    // {
    //   image: "/assets/images/brands/brands1/Carmesi.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/Davidoff.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/ducray_logo.png"
    // },
   
    // {
    //   image: "/assets/images/brands/brands1/menmoms.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/petstar.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/Slay_Coffee.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/Typhoo.png"
    // },
    // {
    //   image: "/assets/images/brands/brands1/Novus.png"
    // }, 
     
    // {
    //   image: "/assets/images/brands/brands1/goqii.png"
    // }, 


  ];
 
brandImages =[
  
    {
      image: "/assets/images/brands/brands1/image 65.png"
    },
    {
      image: "/assets/images/brands/brands1/image 66.png"
    },
  {
      image: "/assets/images/brands/brands1/image 68.png"
    },
  {
      image: "/assets/images/brands/brands1/Bosch_logo 1.png"
    }, 
   {
      image: "/assets/images/brands/brands1/BrintonLogo.png"
    },
   {
      image: "/assets/images/brands/brands1/Hansaplast_Logo.png"
    },
    {
      image: "/assets/images/brands/brands1/himalaya_wellness_logo.png"
    },
  {
      image: "/assets/images/brands/brands1/revlon.png"
    }, 
    {
      image: "/assets/images/brands/brands1/purify.png"
    }, 
    {
      image: "/assets/images/brands/brands1/jyothilabs.png"
    }, 
    {
      image: "/assets/images/brands/brands1/happilo.png"
    }, 
    {
      image: "/assets/images/brands/new_brands/dr_reddy.png"
    },
    {
      image: "/assets/images/brands/new_brands/gosvish.png"
    },
    {
      image: "/assets/images/brands/new_brands/loreal.png"
    },
    {
      image: "/assets/images/brands/new_brands/sekyo.png"
    },
    {
      image: "/assets/images/brands/new_brands/smytten.png"
    }, 
  
] 

brandImagesGrouped: any[][] = [];
// groupBrandImages() {
//   const groupSize = 5; // Number of logos per slide
//   for (let i = 0; i < this.brandImages.length; i += groupSize) {
//     this.brandImagesGrouped.push(this.brandImages.slice(i, i + groupSize));
//   }
// }

groupBrandImages() {
  const groupSize = 5; // show 5 at a time
  const n = this.brandImages.length;

  for (let i = 0; i < n; i++) {
    let group = [];
    for (let j = 0; j < groupSize; j++) {
      group.push(this.brandImages[(i + j) % n]); // wrap around with modulo
    }
    this.brandImagesGrouped.push(group);
  }
}


  scrollTOView(){
    window.scrollTo(0, 0);
  }
  onClick(){
    let hom=window.location.href
    if(hom.search('home')!=-1)
    window.scrollTo(0, 0);
    else{
    this.router.navigate(['/track-order']);
    setTimeout(()=>{
    this.scrollTOView();
    },800)
    } 
  }
  
  onClick1(){
    let hom=window.location.href
    if(hom.search('home')!=-1)
    window.scrollTo(0, 0);
    else{
      this.router.navigate(['/contacts']);
    setTimeout(()=>{
    this.scrollTOView();
    },800)
    
    } 
  }

  scrollTOView3(){

    window.scrollTo(0, 2);
    
  }

  onClick3(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/new-pricing']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }

  onClick12(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/partners']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }

  onClick4(){
    console.log("cdscds")
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{ 
    
    this.router.navigate(['/services']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }
  route_home(){
    this.router.navigate(['/'])
  }

  onClick5(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/ondc']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }

  onClick6(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 2);
    
    else{
    
    this.router.navigate(['/about']);
    

    setTimeout(()=>{
    
    this.scrollTOView3();
    
    },800)
    
    } 
  }
  openDropdown: string | null = null;


  openDropdownMenu(menu: string) {
    this.openDropdown = menu;
  }

  closeDropdown() {
    this.openDropdown = null;
  }
  call(){
    this.router.navigate(['/signin-page']);


  }

  


  

}
